import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
      backend: {
          loadPath: "/locales/{{ns}}_{{lng}}.json",
          parse: (data: string) => {
              try {
                  return JSON.parse(data);
              } catch (e) {
                  console.error(`Error parsing JSON: Check localization .json files for validity!`, e);
                  return {};
              }
          }
      },
    detection: {
      order: ["localStorage", "querystring"],
      lookupLocalStorage: "usrLng",
      lookupQuerystring: "lng"
    },
    defaultNS: "common",
    ns: ["common", "pages", "parts", "candidate_portal"],
    //lng: 'et',
    fallbackLng: "et",
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      format: function(value, format) {
        if (format === "capitalize") {
          return typeof value === "string"
            ? value.charAt(0).toUpperCase() + value.slice(1)
            : value;
        }
        if (format === "uppercase") {
          return typeof value === "string" ? value.toUpperCase() : value;
        }
      }
    },
    react: {
      //wait: true, // this is v9
      useSuspense: true
    }
  });

export default i18n;
